import { c as _c } from "react/compiler-runtime";
import type { DeviceInsightKind, Entity } from '@onefootprint/request-types/dashboard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { DeviceInsightEvent } from '@/components/entities/components/details/hooks/use-entity-device-insights';
import hasDataIdentifier from '@/utils/has-data-identifier';
export type MultiSelectOptionValue = 'businessAddress' | 'residentialAddress' | DeviceInsightKind;
export type MultiSelectOption = {
  label: string;
  value: MultiSelectOptionValue;
};
const useMultiSelectOptions = (entity, deviceInsights) => {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "deviceInsights"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let allOptions;
  let kinds;
  if ($[1] !== deviceInsights || $[2] !== entity || $[3] !== t) {
    allOptions = [];
    kinds = Array.from(new Set(deviceInsights.map(_temp)));
    const kindToText = {
      identify: t(_temp2),
      handoff: t(_temp3),
      auth_event: t(_temp4)
    };
    kinds.forEach(kind => {
      allOptions.push({
        value: kind,
        label: kindToText[kind]
      });
    });
    const hasBusinessAddress = hasDataIdentifier(entity, "business.address_line1");
    if (hasBusinessAddress) {
      let t1;
      if ($[6] !== t) {
        t1 = t(_temp5);
        $[6] = t;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      let t2;
      if ($[8] !== t1) {
        t2 = {
          value: "businessAddress",
          label: t1
        };
        $[8] = t1;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      allOptions.push(t2);
    }
    const hasResidentialAddress = hasDataIdentifier(entity, "id.address_line1");
    if (hasResidentialAddress) {
      let t1;
      if ($[10] !== t) {
        t1 = t(_temp6);
        $[10] = t;
        $[11] = t1;
      } else {
        t1 = $[11];
      }
      let t2;
      if ($[12] !== t1) {
        t2 = {
          value: "residentialAddress",
          label: t1
        };
        $[12] = t1;
        $[13] = t2;
      } else {
        t2 = $[13];
      }
      allOptions.push(t2);
    }
    $[1] = deviceInsights;
    $[2] = entity;
    $[3] = t;
    $[4] = allOptions;
    $[5] = kinds;
  } else {
    allOptions = $[4];
    kinds = $[5];
  }
  const containsModernEvents = kinds.includes("identify") || kinds.includes("handoff");
  let t1;
  if ($[14] !== allOptions) {
    t1 = [...allOptions];
    $[14] = allOptions;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let defaultSelectedOptions = t1;
  if (containsModernEvents) {
    let t2;
    if ($[16] !== defaultSelectedOptions) {
      t2 = defaultSelectedOptions.filter(_temp7);
      $[16] = defaultSelectedOptions;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    defaultSelectedOptions = t2;
  }
  const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions);
  let t2;
  if ($[18] !== allOptions) {
    t2 = newValues => {
      const newOptions = newValues.map(value => allOptions.find(option_0 => option_0.value === value)).filter(_temp8);
      setSelectedOptions(newOptions);
    };
    $[18] = allOptions;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  const handleOptionsChange = t2;
  let t3;
  if ($[20] !== allOptions || $[21] !== handleOptionsChange || $[22] !== selectedOptions) {
    t3 = {
      allOptions,
      selectedOptions,
      handleOptionsChange
    };
    $[20] = allOptions;
    $[21] = handleOptionsChange;
    $[22] = selectedOptions;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  return t3;
};
export default useMultiSelectOptions;
function _temp(deviceInsight) {
  return deviceInsight.event.data.kind;
}
function _temp2($) {
  return $.insightKind.identify;
}
function _temp3($_0) {
  return $_0.insightKind.handoff;
}
function _temp4($_1) {
  return $_1.insightKind.auth_event;
}
function _temp5($_2) {
  return $_2.select.businessAddress;
}
function _temp6($_3) {
  return $_3.select.residentialAddress;
}
function _temp7(option) {
  return option.value !== "auth_event";
}
function _temp8(option_1) {
  return option_1 !== undefined;
}